const Resume = () => {
    return (
        <div style={{ padding: '16px' }}>
            <h1>Custom Reports</h1>
        </div>
    );
}

export {Resume};